module.exports = __webpack_public_path__ + "img/logo.75a206be.png";